// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"AllCustomers_headerContainer__1bTkH","custom_filter_bulk_import":"AllCustomers_custom_filter_bulk_import__1Zn9l"};